import { useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomerForm from 'templates/CheckoutPage/ShippingSection/ShippingAddress/CustomerForm';
import ShippingAddressSummary from './ShippingAddressSummary';

const ShippingAddress = ({
    address,
    addressNewsletterText,
    addressSeprateShippingText,
    addressTermsText,
    basketType,
    checkSeparateShippingAddress = () => null,
    currentCheckoutStep,
    infoBoxes,
    separateBillingAndShippingAddress,
    setCurrentCheckoutStep,
    setSeparateBillingAndShippingAddress,
    shippingAddress,
    shippingStep,
    ...rest
}) => {
    useEffect(() => {
        // Should prolly happen only if they enable separate shipping but fills in the same for both.
        if (separateBillingAndShippingAddress !== checkSeparateShippingAddress()) {
            setSeparateBillingAndShippingAddress(!separateBillingAndShippingAddress);
        }
    }, [currentCheckoutStep]);

    // We are currently editing address
    if (currentCheckoutStep === shippingStep) {
        return (
            <CustomerForm
                addressNewsletterText={addressNewsletterText}
                addressSeprateShippingText={addressSeprateShippingText}
                addressTermsText={addressTermsText}
                basketType={basketType}
                infoBoxes={infoBoxes}
                proceedToCheckoutStep={() => setCurrentCheckoutStep(shippingStep + 1)}
                separateBillingAndShippingAddress={separateBillingAndShippingAddress}
                setSeparateBillingAndShippingAddress={setSeparateBillingAndShippingAddress}
                {...rest}
            />
        );
    }

    // Display summary of address information
    if (address || shippingAddress) {
        return (
            <ShippingAddressSummary
                address={address}
                separateBillingAndShippingAddress={separateBillingAndShippingAddress}
                shippingAddress={shippingAddress}
                {...rest}
            />
        );
    }

    return null;
};

ShippingAddress.propTypes = {
    address: PropTypes.object,
    addressNewsletterText: PropTypes.object,
    addressSeprateShippingText: PropTypes.object,
    addressTermsText: PropTypes.object,
    basketType: PropTypes.string,
    checkSeparateShippingAddress: PropTypes.func,
    currentCheckoutStep: PropTypes.number.isRequired,
    infoBoxes: PropTypes.array,
    proceedToCheckoutStep: PropTypes.func,
    separateBillingAndShippingAddress: PropTypes.bool,
    setCurrentCheckoutStep: PropTypes.func.isRequired,
    setSeparateBillingAndShippingAddress: PropTypes.func,
    shippingAddress: PropTypes.object,
    shippingStep: PropTypes.number.isRequired,
};

export default ShippingAddress;
